import { createTheme } from "@mui/material/styles";

export const BODY_FONT_FAMILY =
  '"Inter", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
export const HEADING_FONT_FAMILY =
  '"Overpass", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';

export const theme = createTheme({
  typography: {
    fontSize: 12,
    fontFamily: BODY_FONT_FAMILY,
    button: { fontFamily: HEADING_FONT_FAMILY },
    h5: { fontFamily: HEADING_FONT_FAMILY },
    h6: { fontFamily: HEADING_FONT_FAMILY },
    h7: { fontFamily: HEADING_FONT_FAMILY },
  },
  palette: {
    primary: {
      main: "#4B93F6",
    },
    secondary: {
      main: "#565452",
    },
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "#565452",
    },
    white: {
      main: "#FFFFFF",
    },
    black: {
      main: "#000000",
    },
    bg: {
      main: "rgba(0, 0, 0, 0.75)",
      secondary: "#EFF1F4",
    },
    divider: "#E0E0E0",
    error: {
      main: "#D32F2F",
    },
  },
  shape: {
    borderRadius: 0,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          paddingTop: "4px",
          paddingRight: "4px",
          paddingBottom: "4px",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          paddingTop: "4px",
          paddingRight: "4px",
          paddingBottom: "4px",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(255, 255, 255, 0.9)",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderColor: theme.palette.divider,
        }),
      },
    },
    MuiTypography: {
      styleOverrides: {
        h5: {
          fontSize: "20px",
          fontWeight: "500",
          paddingTop: "3px", // Heading font (Overpass) baseline is offset high, so adjust
        },
        h6: {
          paddingTop: "3px",
          "&:not(:first-of-type)": {
            marginTop: "8px",
          },
        },
        h7: {
          paddingTop: "3px",
        },
        body2: {
          fontSize: "11px",
        },
      },
    },
  },
});
